export default __webpack_public_path__ + "static/DRMC-videoMiseEnAvant-fadc828aaa61b269a127c133010d0b69.mp4";